module.exports = __webpack_public_path__ + "static/media/avar1.5e8bcceb.jpeg";